import React from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import Tippy from "@tippy.js/react";
import "tippy.js/dist/tippy.css";

import GanttPackWork from "./ganttTaskPackInfo";
import GanttPackDeadlines from "./ganttDeadlinePackInfo";
import {
  getWorkPackageTitles,
  // getLastTaskId,
  addWorkPackage,
} from "../../store/entities/tasks";
import {
  getProjectLength,
  getProjectStatus,
} from "../../store/entities/project";
import {
  wpInfoColor,
  delTitleColor,
  milTitleColor,
  taskDeadlineGap,
  totalDaysColor,
  handleSectionStatus,
} from "../../helpers";
import add from "../../images/add-white.png";
import addGrey from "../../images/add-grey.png";
import qMark from "../../images/qMark.png";
import { getSelectedProject } from "../../store/user";

function GanttChartLeft(props) {
  const dispatch = useDispatch();

  const { workPackages, deliverables, milestones, totalDays } = props.data;
  const workPackageCount = workPackages.length;

  const taskPackTitles = useSelector(getWorkPackageTitles);
  const projectLength = useSelector(getProjectLength);
  const { maxWorkPackages } = useSelector(getSelectedProject);
  const ganttComplete = useSelector(getProjectStatus).gantt;

  function createNewWorkPackage() {
    console.log(projectLength);
    dispatch(addWorkPackage({ projectLength }));
  }

  function toggleComplete() {
    handleSectionStatus("gantt");
  }

  return (
    <PageContainer>
      <div id="details" className="leftEditSpace">
        <div className="monthHeaderSpacer"></div>
        {workPackages.length
          ? workPackages.map((task, index) => {
              return (
                <GanttPackWork
                  key={index}
                  index={index}
                  packData={task}
                  workPackageCount={workPackageCount}
                  titleBarColor={wpInfoColor}
                  title={taskPackTitles[index]}
                />
              );
            })
          : null}
        <div className="divider">
          {workPackages.length >= maxWorkPackages ? (
            <Tippy content={`Maximum ${maxWorkPackages} work packages`}>
              <button className="totalDays content">
                <img src={addGrey} alt="add" />
              </button>
            </Tippy>
          ) : (
            <Tippy content="Add a new work package">
              <button
                className="totalDays content"
                onClick={createNewWorkPackage}
              >
                <img src={add} alt="add" />
              </button>
            </Tippy>
          )}

          <div className="totalDays content">
            <h3>{totalDays ? totalDays : null}</h3>
            <Tippy content="Total days">
              <div className="info">
                <img src={qMark} alt="info" />
              </div>
            </Tippy>
          </div>
        </div>
        <GanttPackDeadlines
          workPackData={deliverables}
          titleBarColor={delTitleColor}
          title={"Deliverables"}
        />
        <GanttPackDeadlines
          workPackData={milestones}
          titleBarColor={milTitleColor}
          title={"Milestones"}
        />
      </div>
      <button onClick={toggleComplete} className="toggleComplete">
        {ganttComplete ? "Edit Gantt Chart" : "Mark Gantt Chart as complete"}
      </button>
    </PageContainer>
  );
}
export default GanttChartLeft;

const PageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start; // for mark as complete
  margin-right: 10px;
  @media screen and (max-width: 550px) {
    margin-right: 0;
    width: 100%;
  }
  .leftEditSpace {
    /* border: 1px solid red; */
    position: relative;
  }
  .divider {
    height: ${taskDeadlineGap};
    width: 100%;
    padding: 5px 0px 0px 32px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .content {
      position: relative;
      height: 30px;
      padding-right: 34px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      color: ${totalDaysColor};
    }
    .info {
      position: absolute;
      margin: 0;
      right: 0px;
      width: 19px;
      height: 19px;
    }
    button {
      height: 40px;
      background-color: transparent;
      border: none;
      padding: 0;
      display: flex;
    }
    img {
      margin: none;
      height: 80%;
      width: auto;
    }
  }
  .button {
    position: absolute;
    top: 3px;
    background-color: ${wpInfoColor};
    border: none;
    color: white;
    font-weight: 600;
    padding: 5px 15px;
    width: 100px;
  }
  .complete {
    left: 0;
    z-index: 3;
  }
  .toggleComplete {
    transition: transform 0.3s;
    :hover {
      /* text-decoration: underline; */
      transform: scale(1.08);
    }
  }
`;
